var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTag = function SvgTag(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.625 5.86 4.36 6.14-4.36 6.14q-.61.844-1.64.844H5.014q-.796 0-1.406-.562Q3 17.812 3 17.016V6.984q0-.796.61-1.359.608-.61 1.406-.61h10.968q1.032 0 1.641.844"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTag);
export { ForwardRef as ReactComponent };